import { render, staticRenderFns } from "./mobidtyCompany.vue?vue&type=template&id=68b1b2a1&scoped=true&"
import script from "./mobidtyCompany.vue?vue&type=script&lang=js&"
export * from "./mobidtyCompany.vue?vue&type=script&lang=js&"
import style0 from "./mobidtyCompany.vue?vue&type=style&index=0&id=68b1b2a1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b1b2a1",
  null
  
)

export default component.exports